export const API = process.env.NODE_ENV === 'development'
  ? 'http://localhost:8080'
  : 'https://api.bqflow.site';
